import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private ProductSettings Types */
import {
  Settings,
  _ProductListings
} from '../namespace-helper'

import _ from 'lodash'

const selectedProductTemplate = {
  id: 0,
  name: '',
  product_description: {
    description: null
  }
}

const selectedPriceCalculationTemplate = {
  id: 0,
  products_id: 0,
  products_listings_price_calculations_additional_costs: [],
  products_listings_price_calculations_discounts: [],
  currency: {
    id: 1,
    name: 'EUR'
  },
  product: {
    manufacturer: {
      name: null
    }
  },
  margin: null
}

export default {
  namespaced: true,
  state: {
    products: [],
    priceCalculations: [],
    selectedProduct: _.cloneDeep(selectedProductTemplate),
    selectedPriceCalculation: _.cloneDeep(selectedPriceCalculationTemplate),
    addEditDialogState: false,
    calculationDialogState: false
  },
  mutations: {
    [_ProductListings.mutations.setDialogState] (state) {
      state.addEditDialogState = !state.addEditDialogState
    },
    [_ProductListings.mutations.setCalculationDialogState] (state) {
      state.calculationDialogState = !state.calculationDialogState
    },
    [_ProductListings.mutations.setSelectedPriceCalculation] (state, payload) {
      if (payload !== null) {
        state.selectedPriceCalculation = payload
      } else {
        state.selectedPriceCalculation = _.cloneDeep(selectedPriceCalculationTemplate)
      }
    },
    [_ProductListings.mutations.setPriceCalculations] (state, payload) {
      state.priceCalculations = payload
    }
  },
  actions: {
    [_ProductListings.actions.saveProduct] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      var url = null
      return new Promise((resolve, reject) => {
        if (payload.product_id === 0) {
          url = API_URL + '/api/v1/shopify/uploadProduct'

          axios.post(url, {}, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r.data.data)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else if (payload.shopify_id !== null) {
          url = API_URL + '/api/v1/shopify/updateProduct'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r.data.data)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_ProductListings.actions.deleteProduct] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      var url = API_URL + '/api/v1/shopify/deleteProduct'

      axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        SuccessHandler.handleApiSuccess(store, r.data.message)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_ProductListings.actions.loadProduct] (context, payload) {
      console.log('loadProduct: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/shopify/singleProduct'

      const data = JSON.stringify(payload)

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductListings.actions.createProductSyncJob] (context, payload) {
      console.log('syncProducts: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/productListingSyncs'

      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductListings.actions.updateProductSyncJob] (context, payload) {
      console.log('updateProductSyncJob: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/productListingSyncs/' + payload.id

      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          resolve(r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductListings.actions.loadRunningSyncJob] (context, payload) {
      console.log('loadRunningSyncJob: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/productListingSyncs?status=running'

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          resolve(r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductListings.actions.setActiveCalculationState] (context, payload) {
      console.log('setActiveCalculationState: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/productListingPriceCalculations/' + payload.id + '/activeState'

      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          SuccessHandler.handleApiSuccess(store, r.data.message)
          ErrorHandler.clear(store)
          resolve(r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductListings.actions.loadPriceCalculations] (context, payload) {
      console.log('loadPriceCalculations: ' + JSON.stringify(payload))
      console.log('loadPriceCalculations: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/productListingPriceCalculations/product/' + payload.id + '?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;reference:like;manufacturer.name:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_ProductListings.mutations.setPriceCalculations, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_ProductListings.actions.savePriceCalculation] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/productListingPriceCalculations'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/productListingPriceCalculations/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_ProductListings.actions.removeDiscount] (context, payload) {
      var url = API_URL + '/api/v1/productCalculationDiscounts/' + payload
      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductListings.actions.removeAddCost] (context, payload) {
      var url = API_URL + '/api/v1/productCalculationAdditionalCosts/' + payload
      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_ProductListings.actions.openCloseDialog] ({ commit }) {
      commit(_ProductListings.mutations.setDialogState)
    },
    [_ProductListings.actions.openClosePriceCalculationDialog] ({ commit }) {
      commit(_ProductListings.mutations.setCalculationDialogState)
    },
    [_ProductListings.actions.setSelectedPriceCalculation] ({ commit }, payload) {
      commit(_ProductListings.mutations.setSelectedPriceCalculation, payload)
    },
    [_ProductListings.actions.resetState] ({ commit }, payload) {
      commit(_ProductListings.mutations.setSelectedPriceCalculation, null)
      commit(_ProductListings.mutations.setPriceCalculations, [])
    }
  },
  getters: {
    [_ProductListings.getters.getDialogState] (state) {
      return state.addEditDialogState
    },
    [_ProductListings.getters.getCalculationDialogState] (state) {
      return state.calculationDialogState
    },
    [_ProductListings.getters.getSelectedProduct] (state) {
      return state.selectedProduct
    },
    [_ProductListings.getters.getSelectedPriceCalculation] (state) {
      return state.selectedPriceCalculation
    },
    [_ProductListings.getters.priceCalculations] (state) {
      return state.priceCalculations
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/ProductListings/productListings.js